/**
 * 日本語 IME の変換確定 Enter かどうか。
 *
 * 変換中の Enter は `isComposing` が立つ。Safari は変換確定の Enter を compositionend の後に
 * `isComposing=false` で投げてくることがあり、そのときは keyCode が 229 になるので両方を見る。
 * 動画エディタ内の「Enter で確定 / 送信」する入力欄はすべてこれでガードする
 * (シーン名・焼き込み文字・編集名・最新シナリオ複製の名前・AI ディレクターへの返答)。
 */
import type { KeyboardEvent } from 'react';

export function isComposingEnter(event: KeyboardEvent<HTMLElement>): boolean {
  return event.nativeEvent.isComposing || event.keyCode === 229;
}
